module.exports = __webpack_public_path__ + "img/pl-dub.8d83f61b.jpg";